module.exports = __webpack_public_path__ + "img/home-about-img1.2508e666.png";